"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
var _utils = require("../../utils");
var _ = require("./..");
var _components = require("../../components");
var _utils2 = require("./utils");
var _CubbyFooter = _interopRequireDefault(require("./CubbyFooter"));
var _components2 = require("./components");
var _ScreenTitle = require("./components/ScreenTitle");
var _excluded = ["appointment", "visible", "onCancel"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ManagerAppointmentCancelCubbyContent(_ref) {
  var appointment = _ref.appointment,
    onCancel = _ref.onCancel,
    onSuccess = _ref.onSuccess;
  var _useState = (0, _react.useState)(_utils2.ManageAppointmentTarget.One),
    _useState2 = _slicedToArray(_useState, 2),
    action = _useState2[0],
    setAction = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    reason = _useState4[0],
    setReason = _useState4[1];
  var _useSendNotifications = (0, _components2.useSendNotificationsToggle)(),
    toggleProps = _useSendNotifications.toggleProps,
    sendNotifications = _useSendNotifications.sendNotifications;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  var _useRequest = (0, _utils.useRequest)(function () {
      return (0, _utils.getBookingsForAnalysisUrl)({
        recurringRuleId: appointment.recurringRule.id,
        after: (0, _momentTimezone.default)().toDate()
      });
    }, {
      ready: appointment.recurringRule,
      formatResult: function formatResult(_ref2) {
        var items = _ref2.items;
        return (0, _lodash.first)((0, _lodash.sortBy)(items, ['startsAt']));
      }
    }),
    earliestUpcomingAppointment = _useRequest.data,
    earliestUpcomingAppointmentLoading = _useRequest.loading;
  var handleSuccess = function handleSuccess() {
    setTimeout(onSuccess, _utils.SHOW_MODAL_SUCCESS_DURATION);
    _utils.toast.success({
      title: 'Appointment successfully canceled!'
    });
  };
  var _useRequest2 = (0, _utils.useRequest)(function () {
      return {
        method: 'DELETE',
        url: (0, _utils.getCancelAppointmentUrl)({
          appointmentId: appointment.id,
          accountId: appointment.clinicianId,
          query: {
            sendNotifications: sendNotifications
          }
        }),
        data: {
          reason: reason
        }
      };
    }, {
      manual: true,
      onSuccess: handleSuccess
    }),
    deleteAppointmentLoading = _useRequest2.loading,
    deleteAppointment = _useRequest2.run;
  var _useRequest3 = (0, _utils.useRequest)(function () {
      return {
        method: 'DELETE',
        url: (0, _utils.getCancelRecurringAppointmentUrl)({
          recurringRuleId: appointment.recurringRuleId,
          query: {
            sendNotifications: sendNotifications
          }
        }),
        data: {
          reason: reason
        }
      };
    }, {
      manual: true,
      onSuccess: handleSuccess
    }),
    deleteRecurringAppointmentLoading = _useRequest3.loading,
    deleteRecurringAppointment = _useRequest3.run;
  var title = "Cancel ".concat(appointment.recurringRuleId ? 'recurring ' : '', "appointment");
  var appointmentToCheck = action === _utils2.ManageAppointmentTarget.All ? earliestUpcomingAppointment : appointment;
  var actionDisabled = (0, _utils2.isBookingLateChange)(appointmentToCheck === null || appointmentToCheck === void 0 ? void 0 : appointmentToCheck.startsAt) ? !(0, _lodash.isString)(reason) : false;
  var actionCallback = action === _utils2.ManageAppointmentTarget.All ? deleteRecurringAppointment : deleteAppointment;
  return earliestUpcomingAppointmentLoading ? /*#__PURE__*/_react.default.createElement(_.SpinPlaceholder, null) : /*#__PURE__*/_react.default.createElement("div", {
    className: "px-[24px] flex flex-col gap-y-[24px]"
  }, /*#__PURE__*/_react.default.createElement(_ScreenTitle.ScreenTitle, null, title), appointment.recurringRuleId && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "Do you want to cancel this appointment only or all future appointments?"), /*#__PURE__*/_react.default.createElement(_components2.ChangeOneOrAll, {
    value: action,
    actionText: "Cancel",
    onActionSelect: setAction
  })), /*#__PURE__*/_react.default.createElement(_components2.LateChangeReason, {
    startsAt: appointmentToCheck.startsAt,
    onSelect: setReason
  }), (0, _utils.isAdmin)(user) && /*#__PURE__*/_react.default.createElement(_components2.SendNotificationsToggle, toggleProps), /*#__PURE__*/_react.default.createElement(_CubbyFooter.default, {
    actionDisabled: actionDisabled || deleteAppointmentLoading || deleteRecurringAppointmentLoading,
    actionText: "Confirm",
    onAction: actionCallback,
    onCancel: onCancel
  }));
}
function ManagerAppointmentCancelCubby(_ref3) {
  var appointment = _ref3.appointment,
    visible = _ref3.visible,
    onCancel = _ref3.onCancel,
    props = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/_react.default.createElement(_components.Cubby, {
    visible: visible,
    overlayStyles: "fixed top-0 right-0 w-screen h-screen z-cubby-overlay",
    cubbyStyles: "fixed bottom-0 right-0 h-[calc(100vh-theme(spacing.app-header-height))] w-[476px] pt-[36px] pb-[24px] z-cubby",
    onClose: onCancel
  }, visible && appointment && /*#__PURE__*/_react.default.createElement(ManagerAppointmentCancelCubbyContent, _extends({
    appointment: appointment,
    onCancel: onCancel
  }, props)));
}
var _default = ManagerAppointmentCancelCubby;
exports.default = _default;